import * as actionTypes from './actionTypes';

export const setErrors = (payload) => ({
  type: actionTypes.SET_ERRORS,
  payload,
});

export const getChannelPartners = (params) => ({
  type: actionTypes.GET_CHANNEL_PARTNERS,
  params
});

export const createChannelPartner = (payload) => ({
  type: actionTypes.CREATE_CHANNEL_PARTNER,
  payload
});

export const updateChannelPartner = (payload) => ({
  type: actionTypes.UPDATE_CHANNEL_PARTNER,
  payload
});

export const updateChannelPartnerStatus = (Id) => ({
  type: actionTypes.UPDATE_CHANNEL_PARTNER_STATUS,
  Id
});

export const deleteChannelPartner = (Id) => ({
  type: actionTypes.DELETE_CHANNEL_PARTNER,
  Id
});

export const setFilters = (payload) => ({
  type: actionTypes.SET_FILTERS,
  payload,
});
